import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\'ml-auto\'>\n  {{yield}}\n</div>\n",{ moduleName: "web-app/components/x-form/multiple-choice/answers/index.hbs" })